import appState from '../util/appState';
import common from '../routes/common';

// Simple throttle function e.g. throttle(function(e) { foo() }, 500)
function throttle(callback, limit=150) {
  var waiting = false;
  return function() {
    if (!waiting) {
      callback.apply(this, arguments);
      waiting = true;
      setTimeout(function() {
        waiting = false;
      }, limit);
    }
  }
}

const home = {
  init() {
    // JavaScript to be fired on the home page
    document.querySelectorAll('ul.checkable li').forEach(el => {
      el.addEventListener('click', e => {
        el.classList.toggle('checked');
        if (document.querySelectorAll('ul.checkable li').length == document.querySelectorAll('ul.checkable li.checked').length) {
          location.href = 'https://www.youtube.com/watch?v=dQw4w9WgXcQ';
        }
      });
    });

    // Silly sparkles
    document.querySelectorAll('.img-link,svg.logo').forEach((el) => {
      el.addEventListener('mousemove', throttle(function(e) {
        [.7, .9, .8, .5, .25, .6, .4, .3, .2].forEach(function (i) {
          var spread = 75;
          var j = (1 - i) * spread;
          var el = document.createElement('div');
          var randomnum = Math.floor(Math.random() * (10 * spread - 1 * spread) + 1 * spread) / (1 * spread);
          var rSize = randomnum/200;
          var duration = Math.round(Math.random() * i * 1000) + 250;
          el.className = 'diamond-shape';
          el.style.position = 'absolute';
          el.style.animationDuration = (duration/1000)+'s';
          el.style.transform = `scale(${rSize})`
          el.style.top = (e.pageY + 20 + Math.round(Math.random() * j - j / 2) - 75) + 'px';
          el.style.left = (e.pageX + Math.round(Math.random() * j - j / 2) - 50) + 'px';
          el.style.opacity = randomnum/10;
          el.style.pointerEvents = 'none';
          document.body.appendChild(el);
          window.setTimeout(function () {
            document.body.removeChild(el);
          }, duration+1000);
        });
      }, 50), false);
    })
  },


  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};

export default home
